<app-grid
    [data]="displayData"
    [cols]="columns"
    [sortable]="true"
    [filterable]="false"
    [reorderable]="false"
    [allowGridSave]="false"
    [showColumnSelector]="false"
    [applyLocalPagination]="true" />
